import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { applyGlass } from '../../theme/glassEffect';

const CookieContainer = styled(motion.div)`
  ${applyGlass('dark')}
  position: fixed;
  bottom: 24px;
  right: 24px;
  left: auto;
  transform: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 380px;
  z-index: 1000;
  
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
    left: 16px;
    width: auto;
    max-width: none;
  }
`;

const Message = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Button = styled.button`
  padding: ${props => props.primary ? '10px 24px' : '9px 24px'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  ${props => props.primary ? `
    background: #5CD3FF;
    color: #000;
    border: none;

    &:hover {
      background: #4CC3FF;
    }
  ` : `
    background: rgba(255, 255, 255, 0.03);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.06);
      border-color: rgba(255, 255, 255, 0.2);
    }
  `}
`;

const ManageLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-decoration: underline;
  transition: all 0.2s ease;
  margin-right: auto;

  &:hover {
    color: white;
  }
`;

const CookieConsent = ({ onAccept, onDecline, onManage }) => {
  return (
    <CookieContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
    >
      <Message>
        We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
      </Message>
      <ButtonGroup>
        <ManageLink onClick={onManage}>
          Manage
        </ManageLink>
        <Button onClick={onDecline}>
          Decline
        </Button>
        <Button primary onClick={onAccept}>
          Accept
        </Button>
      </ButtonGroup>
    </CookieContainer>
  );
};

export default CookieConsent;